<template>
  <div class="custom-modal new-item">
    <div class="modal-body">
      <div class="select-box text-gray">
        <label>Designer</label>
        <select class="form-control text-gray" v-model="newItem.brandId">
          <option value="" disabled>Choose Designer...</option>
          <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.name }}</option>
        </select>
      </div>
      <div class="select-box text-gray">
        <label>Category</label>
        <select class="form-control text-gray" v-model="newItem.categoryId">
          <option value="" disabled>Choose Category...</option>
          <option v-for="category in categories" :value="category.id" :key="category.id">{{ category.name }}</option>
        </select>
      </div>
      <div class="select-box text-gray">
        <label>Name</label>
        <input class="form-control text-gray" type="text" v-model="newItem.name" placeholder="Enter item name..." />
      </div>
      <div class="select-box text-gray">
        <label>Description</label>
        <textarea class="form-control text-gray" rows="2" v-model="newItem.description" placeholder="Enter item description..."></textarea>
      </div>
      <div class="image-section">
        <label>Add Images here</label>
      </div>
      <div class="preview">
        <!-- All images (uploaded and uploading) -->
        <div v-for="(image, index) in allImages" :key="`image-${image.id}`" class="thumb" :class="{ uploading: image.isUploading }">
          <img :src="image.url || image.preview" :class="{ 'uploading-image': image.isUploading }" @load="onImageLoaded(image.id)" />
          <div v-if="image.isUploading" class="upload-overlay">
            <div class="upload-spinner">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="prevClose" @click="removeImage(index)"><i class="fa fa-times" aria-hidden="true"></i></div>
        </div>

        <div class="thumb placeholder" @click="$refs.fileInput.click()">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
        <input type="file" ref="fileInput" @change="processFile($event)" hidden multiple />
      </div>
      <div class="mb-3">
            <button
              class="btn btn-primary mt-4 buttonWidth buttonColor"
              :class="{active:!disabled}"
              :disabled="disabled"
              @click="addItem()"
            >
              <span v-if="!saving">Add Item</span>
              <processing-spinner v-else :saving="saving"></processing-spinner>
            </button>
      </div>
      <error-message v-if="errorMessage" :errorMessage="errorMessage"></error-message>
    </div>
  </div>
</template>
<script>
import api from '@/services/api'
// import vSelect from 'vue-select'
import ProcessingSpinner from '../processing-spinner'
import ErrorMessage from './error-message'

export default {
  name: 'new-item',
  components: { ErrorMessage, ProcessingSpinner },
  props: ['brands', 'clientId'],
  data () {
    return {
      newItem: {
        brandId: '',
        categoryId: '',
        name: '',
        description: '',
        imageIds: []
      },
      placeholder: 'Select the Brand',
      errorMessage: '',
      saving: false,
      images: [] // All images (uploading and uploaded)
    }
  },
  methods: {
    addItem () {
      this.saving = true
      const payload = {
        brandId: this.newItem.brandId,
        categoryId: this.newItem.categoryId,
        name: this.newItem.name,
        description: this.newItem.description,
        imageIds: this.newItem.imageIds,
        clientId: this.clientId
      }
      api
        .post(
          '/api/stylist/white-glove-quotes',
          payload,
          {
            headers: {
              'Content-Type': 'application/x.fashionphile.v1+json, application/json'
            }
          }
        )
        .then(response => {
          const addedItem = response.data.data
          this.$emit('addedItem', addedItem)
          this.$bvModal.hide('addItem')
        })
        .catch(error => {
          console.log(error)
          this.saving = false
          this.errorMessage = 'Sorry, there was a problem uploading that file'
        })
    },
    processFile (event) {
      const files = Array.from(event.target.files)
      files.forEach(file => {
        // Create preview for immediate display
        const reader = new FileReader()
        reader.onload = (e) => {
          const imageObj = {
            id: Date.now() + Math.random(), // Temporary unique ID
            preview: e.target.result,
            url: null,
            file: file,
            isUploading: true,
            serverId: null
          }
          this.images.push(imageObj)
          this.uploadImage(imageObj)
        }
        reader.readAsDataURL(file)
      })
      this.$refs.fileInput.value = null
    },
    uploadImage (uploadingImage) {
      const formData = new FormData()
      formData.append('image', uploadingImage.file)
      api
        .post(
          '/api/stylist/white-glove-quotes/images',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          // Update the same image object with the URL and server ID
          uploadingImage.url = response.data.url
          uploadingImage.serverId = response.data.id
          this.newItem.imageIds.push(response.data.id)

          // Note: We keep isUploading=true until the image loads
        })
        .catch(() => {
          // Remove from images array on error
          const imageIndex = this.images.findIndex(img => img.id === uploadingImage.id)
          if (imageIndex !== -1) {
            this.images.splice(imageIndex, 1)
          }
          this.errorMessage = 'Sorry, there was a problem uploading that file'
        })
    },
    removeImage (index) {
      const removedImage = this.images[index]
      this.images.splice(index, 1)

      // Remove from imageIds if it has a server ID
      if (removedImage.serverId) {
        const imageIdIndex = this.newItem.imageIds.findIndex(id => id === removedImage.serverId)
        if (imageIdIndex !== -1) {
          this.newItem.imageIds.splice(imageIdIndex, 1)
        }
      }
    },
    onImageLoaded (imageId) {
      // Set isUploading to false only once the real image has loaded (has a URL from server)
      const imageIndex = this.images.findIndex(img => img.id === imageId)
      if (imageIndex !== -1) {
        const image = this.images[imageIndex]
        // Only remove loading state if this is the actual uploaded image (has URL)
        if (image.url) {
          this.images[imageIndex].isUploading = false
        }
      }
    }
  },
  watch: {
    'newItem.brandId' () {
      this.newItem.categoryId = ''
    }
  },
  computed: {
    allImages () {
      return this.images
    },
    categories () {
      const brand = this.brands.find(b => b.id === Number(this.newItem.brandId))
      return brand ? brand.categories : []
    },
    disabled: function () {
      const hasUploadingImages = this.images.some(img => img.isUploading)
      if (
        this.newItem.imageIds.length &&
        this.newItem.brandId &&
        this.newItem.categoryId &&
        this.newItem.name &&
        !this.saving &&
        !hasUploadingImages // Don't allow submission while images are uploading
      ) {
        return false
      }
      return true
    }
  }
}
</script>
<style>
.new-item .d-flex {
  justify-content: center;
}
.new-item .modal-section .d-flex button {
  white-space: nowrap;
}
.new-item textarea.form-control {
  background: #000 !important;
  padding: 5px;
}
.new-item textarea.form-control::placeholder {
  color: #999;
}
.new-item input.form-control::placeholder {
  color: #999;
}
.new-item select.form-control option[disabled] {
  color: #999;
}
.new-item .v-select.vs--open ul {
  margin: 10px 0;
  padding: 10px;
  background: #fff;
  /* -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.5); */
  /* box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.5); */
}
.new-item .v-select.vs--open li {
  line-height: 24px;
  cursor: pointer;
  margin: 0px;
}
.new-item .bx.bx-reset {
  font-size: 16px;
  padding: 5px;
  cursor: pointer;
}
.new-item .vs__selected {
  display: flex;
  background: #fff;
  align-items: center;
}

/* Upload overlay styles */
.new-item .thumb.uploading {
  position: relative;
}

.new-item .uploading-image {
  filter: blur(1px);
  opacity: 0.7;
}

.new-item .upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.new-item .upload-spinner {
  color: #fff;
  font-size: 18px;
}

.new-item .upload-spinner i {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
